/**
 * Message query operations - Delete
 */

import type { ChatId } from '../../types.js';
import { getSupabaseClient } from '../../supabase-client.js';
import { logger } from '../../../logger.js';

/**
 * Delete a single message
 */
export async function deleteMessage(messageId: string): Promise<void> {
  try {
    const client = getSupabaseClient();

    const { error } = await client
      .from('meridian_messages')
      .delete()
      .eq('id', messageId);

    if (error) {
      throw error;
    }
  } catch (error) {
    logger.error('error deleting message', error, { op: 'deleteMessage' });
    throw error;
  }
}

/**
 * Delete all messages for a chat
 */
export async function deleteMessagesByChat(chatId: ChatId): Promise<void> {
  try {
    const client = getSupabaseClient();

    const { error } = await client
      .from('meridian_messages')
      .delete()
      .eq('chat_id', chatId);

    if (error) {
      throw error;
    }
  } catch (error) {
    logger.error('error deleting messages by chat', error, { op: 'deleteMessagesByChat' });
    throw error;
  }
}
